import { ChangeDetectionStrategy, Component, Input, OnChanges } from "@angular/core";

import { BarraAreaBsc, BarrasAreaBscComponent } from "./barras-area-bsc.component";

/** El alcance anual ya calculado por el servidor, sin promediar acumulados trimestrales. */
@Component({
  selector: "app-promedio-anual-area-bsc",
  standalone: true,
  imports: [BarrasAreaBscComponent],
  template: `
    <app-barras-area-bsc [barras]="ordenadas"
      descripcion="Promedio anual por área, de mayor a menor"></app-barras-area-bsc>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromedioAnualAreaBscComponent implements OnChanges {
  @Input() barras: BarraAreaBsc[] = [];
  ordenadas: BarraAreaBsc[] = [];

  ngOnChanges(): void {
    this.ordenadas = this.barras.filter((barra) => barra.real != null)
      .sort((a, b) => (b.real ?? 0) - (a.real ?? 0));
  }
}
